/**
 * Continuous "(0N)" numbering for the professional overview page.
 *
 * The numbers run as one sequence down the whole page, the Overview accordion
 * included. The accordion's "Book a Meeting" and testimonials rows come first
 * when present, so the big editorial sections continue the count after them.
 * Hidden sections are skipped, so the visible numbers stay sequential no matter
 * which sections a professional has.
 */
export interface OverviewSectionPresence {
    hasBookMeeting: boolean;
    hasTestimonials: boolean;
    hasSelectedWork: boolean;
    hasTeam: boolean;
    hasNetwork: boolean;
    hasArticles: boolean;
}

export interface OverviewSectionNumbers {
    selectedWork?: number;
    team?: number;
    network?: number;
    articles?: number;
}

export const getOverviewSectionNumbers = (
    presence: OverviewSectionPresence,
): OverviewSectionNumbers => {
    // Accordion rows come first: Book a Meeting + testimonials, each optional.
    let next =
        (presence.hasBookMeeting ? 1 : 0) + (presence.hasTestimonials ? 1 : 0);
    const assign = (present: boolean) => (present ? (next += 1) : undefined);

    return {
        selectedWork: assign(presence.hasSelectedWork),
        team: assign(presence.hasTeam),
        network: assign(presence.hasNetwork),
        articles: assign(presence.hasArticles),
    };
};

export const formatSectionNumber = (value: number): string =>
    String(value).padStart(2, '0');
